export default {
  // Options.jsx
  items_per_page: '/ sahypa',
  jump_to: 'Git',
  jump_to_confirm: 'tassykla',
  page: 'Sahypa',
  // Pagination.jsx
  prev_page: 'Öňki sahypa',
  next_page: 'Soňky sahypa',
  prev_5: 'Öňki 5 sahypa',
  next_5: 'Soňky 5 sahypa',
  prev_3: 'Öňki 3 sahypa',
  next_3: 'Soňky 3 sahypa',
  page_size: 'Sahypa sany'
};